export default __webpack_public_path__ + "static/MediaContentFour-89d37b15026492e46a45d25a1ec8e7a6.webp";